<ul class="nav nav-tabs detailed-tabs relative page-sub-heading" role="tablist">
    @if (permissionModules.includes('REPORT')) {
<li class="nav-item active">
        <a class="nav-link text-center mt-1 active ml-4" role="tab" data-toggle="tab" href="#general">
            <i class="fa fa-bar-chart"></i> General
        </a>
    </li>
}
    @if (permissionModules.includes('REPORT')) {
<li class="nav-item">
        <a class="nav-link text-center mt-1 ml-4" href="#redesign" routerLink="/reports">
            <i class="fa fa-paint-brush"></i> Redesign
        </a>
    </li>
}
    @if (permissionModules.includes('DEEP-VIEW')) {
<li class="nav-item">
        <a class="nav-link text-center mt-1 ml-4" href="#deepView" routerLink="/reports/deep-view">
            <i class="fa fa-th"></i> Deep View
        </a>
    </li>
}
    @if (permissionModules.includes('SCORE')) {
<li class="nav-item">
        <a class="nav-link text-center mt-1" href="#score" routerLink="/score">
            <i class="fa fa-line-chart"></i> Scores
        </a>
    </li>
}
</ul>
